<template>
  <section>
    <div
        :id="!!id.length ? id : null"
        class="current-residents push-v--desktop--large push-v--tablet--large push-v--mobile--xxlarge"
        data-entrance="from-left"
    >
      <div class="current-residents__container container">
        <div class="row">
          <div
              v-if="title"
              class="current-residents__col col-11 col-md-7 offset-md-1 col-lg-6 offset-lg-1 push-v--desktop--medium push-v--tablet--medium push-v--mobile--medium"
          >
            <h2 class="current-residents__title">{{ title }}</h2>
          </div>
          <div v-swiper:mySwiper="swiperOption">
            <div class="swiper-wrapper">
              <div v-for="(item, index) in itemCollection" :key="index" class="swiper-slide">
                <CurrentResidentCard
                    v-bind="item"
                    :background-shape="backgroundShape(index)"
                    :background-shape-class="backgroundShapeClass(index)"
                />
              </div>
            </div>
            <div slot="button-next" class="swiper-button swiper-button-next"><Arrow /></div>
            <div slot="button-prev" class="swiper-button swiper-button-prev"><Arrow /></div>
          </div>
        </div>
      </div>
    </div>
    <VideoModal />
  </section>
</template>

<script>
import getStatic from '~/utils/get-static';
import CurrentResidentCard from '~/components/components/CurrentResidentCard';
import VideoModal from '~/components/components/VideoModal';

export default {
  components: {
    CurrentResidentCard,
    VideoModal,
  },
  props: {
    id: { type: String, default: '' },
    title: { type: String, default: '' },
    callToVideoText: { type: String, default: '' },
    dragButtonText: { type: String, default: 'Drag' },
    items: {
      type: Array,
      default() {
        return [
          {
            title: 'Anna, 28',
            body: '<p>The collective has made me more outgoing and confident meeting new people</p>',
            image: {
              url: getStatic('/images/content/team/senior-management-1.png'),
              description: 'team member 1',
            },
          },
          {
            title: 'Max, 32',
            body: '<p>The collective has made me more outgoing and confident meeting new people</p>',
            image: {
              url: getStatic('/images/content/team/senior-management-1.png'),
              description: 'team member 1',
            },
          },
          {
            title: 'Adrian, 26',
            body: '<p>The collective has made me more outgoing and confident meeting new people</p>',
            image: {
              url: getStatic('/images/content/team/senior-management-1.png'),
              description: 'team member 1',
            },
          },
        ];
      },
    },
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 4,
        slidesOffsetBefore: 180,
        slidesOffsetAfter: 180,
        spaceBetween: 100,
        centerInsufficientSlides: true,
        keyboard: {
          enabled: true,
        },
        breakpoints: {
          360: {
            slidesPerView: 2,
            spaceBetween: 120,
            slidesOffsetBefore: 57,
            slidesOffsetAfter: 130,
          },
          425: {
            slidesPerView: 2,
            spaceBetween: 120,
            slidesOffsetBefore: 57,
            slidesOffsetAfter: 110,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 150,
            slidesOffsetBefore: 90,
            slidesOffsetAfter: 150,
          },
          1024: {
            slidesOffsetBefore: 100,
            slidesOffsetAfter: 150,
          },
          1440: {
            slidesPerView: 3,
            slidesOffsetBefore: 160,
            spaceBetween: -10,
            slidesOffsetAfter: 20,
          },
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    };
  },
  computed: {
    itemCollection() {
      if (this.items && !this.items.length) {
        return [this.items];
      }

      return this.items;
    },
  },
  methods: {
    backgroundShape(index) {
      switch (index % 3) {
        case 0:
          return 'ShapeCarousel1';
        case 1:
          return 'ShapeCarousel2';
        case 2:
          return 'ShapeCarousel3';
        default: {
          return 'ShapeCarousel1';
        }
      }
    },
    backgroundShapeClass(index) {
      switch (index % 3) {
        case 0:
          return 'current-resident-card__carousel1';
        case 1:
          return 'current-resident-card__carousel2';
        case 2:
          return 'current-resident-card__carousel3';
        default: {
          return 'current-resident-card__carousel1';
        }
      }
    },
  },
};
</script>

<style lang="scss">
@import '~/node_modules/swiper/dist/css/swiper.css';
@import '~/assets/scss/atomic/modules/_current-residents.scss';
</style>
